import {
  Card,
  CardContent,
  CardHeader,
  CardTitle,
  CardDescription,
  CardFooter,
} from '@/components/ui/card'
import { Badge } from '@/components/ui/badge'
import { Button } from '@/components/ui/button'
import { ArrowRight, Calendar, MapPin, User, Search } from 'lucide-react'
import { blogPosts } from '@/data/blogPosts'
import { Link } from 'react-router-dom'
import { Input } from '@/components/ui/input'
import { useState, useEffect } from 'react'

const Blog = () => {
  const [searchTerm, setSearchTerm] = useState('')

  useEffect(() => {
    window.scrollTo(0, 0)
    document.title = 'Blog | SuperFut Kids'
  }, [])

  const filteredPosts = blogPosts.filter(
    (post) =>
      post.title.toLowerCase().includes(searchTerm.toLowerCase()) ||
      post.category.toLowerCase().includes(searchTerm.toLowerCase()),
  )

  return (
    <div className="pt-24 pb-16 bg-slate-50 min-h-screen">
      <div className="container px-4 md:px-6 mx-auto">
        {/* Header */}
        <div className="text-center mb-12 animate-fade-in-up">
          <h1 className="text-4xl md:text-5xl font-display font-bold text-super-text mb-4">
            Blog SuperFut
          </h1>
          <p className="text-muted-foreground text-lg max-w-2xl mx-auto mb-8">
            Dicas, novidades e tudo sobre o universo do futebol infantil para
            você e sua família.
          </p>

          <div className="max-w-md mx-auto relative">
            <Search className="absolute left-3 top-1/2 -translate-y-1/2 text-slate-400 h-5 w-5" />
            <Input
              type="search"
              placeholder="Buscar artigos..."
              className="pl-10 h-12 rounded-full border-slate-200 focus:border-super-blue focus:ring-super-blue/20 shadow-sm"
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
            />
          </div>
        </div>

        {/* Posts Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {filteredPosts.length > 0 ? (
            filteredPosts.map((post) => (
              <Card
                key={post.slug}
                className="border-slate-100 shadow-sm hover:shadow-lg transition-all duration-300 group overflow-hidden flex flex-col h-full bg-white animate-fade-in"
              >
                <Link
                  to={`/blog/${post.slug}`}
                  className="block relative h-48 overflow-hidden"
                >
                  <img
                    src={post.image}
                    alt={post.title}
                    className="w-full h-full object-cover transform group-hover:scale-105 transition-transform duration-500"
                  />
                  <div className="absolute top-4 left-4">
                    <Badge className="bg-white/90 text-super-blue hover:bg-white shadow-sm backdrop-blur-sm">
                      {post.category}
                    </Badge>
                  </div>
                </Link>
                <CardHeader className="pb-2">
                  <div className="flex items-center gap-4 text-xs text-slate-500 mb-2">
                    <div className="flex items-center gap-1">
                      <Calendar className="w-3 h-3" />
                      {post.date}
                    </div>
                    <div className="flex items-center gap-1">
                      <MapPin className="w-3 h-3" />
                      {post.location}
                    </div>
                  </div>
                  <Link to={`/blog/${post.slug}`}>
                    <CardTitle className="text-xl font-bold text-slate-800 leading-tight group-hover:text-super-blue transition-colors line-clamp-2">
                      {post.title}
                    </CardTitle>
                  </Link>
                </CardHeader>
                <CardContent className="flex-grow">
                  <CardDescription className="text-slate-600 line-clamp-3">
                    {post.excerpt}
                  </CardDescription>
                </CardContent>
                <CardFooter className="pt-0 border-t border-slate-50 mt-4 pt-4">
                  <div className="flex justify-between items-center w-full">
                    <div className="flex items-center gap-2">
                      <div className="w-6 h-6 rounded-full bg-slate-100 flex items-center justify-center">
                        <User className="w-3 h-3 text-slate-500" />
                      </div>
                      <span className="text-xs font-medium text-slate-600">
                        {post.author}
                      </span>
                    </div>
                    <Button
                      variant="ghost"
                      size="sm"
                      className="text-super-blue hover:text-super-green p-0 h-auto font-bold group/btn"
                      asChild
                    >
                      <Link to={`/blog/${post.slug}`}>
                        Ler mais{' '}
                        <ArrowRight className="w-3 h-3 ml-1 transition-transform group-hover/btn:translate-x-1" />
                      </Link>
                    </Button>
                  </div>
                </CardFooter>
              </Card>
            ))
          ) : (
            <div className="col-span-full text-center py-20 text-slate-500">
              <p>Nenhum artigo encontrado para sua busca.</p>
            </div>
          )}
        </div>
      </div>
    </div>
  )
}

export default Blog
